import TextInput from "./Text"
import EmailInput from "./Email"
import TextArea from "./TextArea"
import NumberInput from "./Number"
import Selection from "./Selection"
import NavigationButton from "./NavigationButton"
import Loading from "./Loading"
import Result from "./Result"
import Summary from "./Summary"
import Checkbox from "./Checkbox"
import DateInput from "./Date"
import CurrencyInput from "./Currency"
import Signature from "./Signature"
import Upload from "./Upload"
import ResultOptionPanels from "./ResultOptionPanels"

export default {
  TextInput,
  EmailInput,
  TextArea,
  NumberInput,
  Selection,
  Loading,
  Result,
  Checkbox,
  DateInput,
  CurrencyInput,
  Summary,
  Signature,
  NavigationButton,
  Upload,
  ResultOptionPanels,
}
